import React from 'react'
import { IconButton, IconButtonProps } from 'theme-ui'

export interface HeaderIconProps extends Omit<IconButtonProps, 'value'> {
  value?: boolean
  label?: string
}

const HeaderIcon = ({
  label = 'Toggle Menu',
  children,
  value,
  sx,
  ...props
}: HeaderIconProps) => {
  return (
    <IconButton
      sx={{
        cursor: 'pointer',
        fill: 'none',
        strokeWidth: '2px',
        stroke: 'text',
        '.paren': {
          opacity: '0',
        },
        '@media (hover: hover) and (pointer: fine)': {
          '&:hover .paren': {
            opacity: '1',
          },
        },
        ...sx,
      }}
      aria-label={label}
      {...props}
    >
      {!value && (
        <svg
          style={{
            width: '50px',
            height: '30px',
            marginTop: '-3px',
            flexShrink: 0,
          }}
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 68 36'
        >
          {children}
          <path
            style={{ transition: 'all 0.2s' }}
            className='paren'
            d='M6.4,1.2c-6.3,10.3-6.3,23.3,0,33.6'
          />
          <path
            style={{ transition: 'all 0.2s' }}
            className='paren'
            d='M61.6,34.8c6.3-10.3,6.3-23.3,0-33.6'
          />
        </svg>
      )}
      {value && (
        <svg
          style={{
            width: '50px',
            height: '30px',
            marginTop: '-3px',
            flexShrink: 0,
          }}
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 68 36'
        >
          <line x1='50.85' y1='29.79' x2='17.15' y2='6.21' />
          <line x1='17.15' y1='29.79' x2='50.85' y2='6.21' />
          <path
            style={{ transition: 'all 0.2s' }}
            className='paren'
            d='M6.4,1.2c-6.3,10.3-6.3,23.3,0,33.6'
          />
          <path
            style={{ transition: 'all 0.2s' }}
            className='paren'
            d='M61.6,34.8c6.3-10.3,6.3-23.3,0-33.6'
          />
        </svg>
      )}
    </IconButton>
  )
}

export default HeaderIcon
